module.exports = __webpack_public_path__ + "static/img/left.a3a740f9.gif";